import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostActivateGeofencePayload, PostActivateGeofenceResponse } from '@/api/geofence/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postActivateGeofence = (payload: PostActivateGeofencePayload): Promise<PostActivateGeofenceResponse> => {
    return axios.post('/device/activate-geofence', payload);
};

type UsePostActivateGeofenceOptions = {
    config?: MutationConfig<typeof postActivateGeofence>;
    data?: PostActivateGeofencePayload;
};

export const usePostActivateGeofence = ({ config }: UsePostActivateGeofenceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postActivateGeofence,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Geofence activated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('activate geofence'),
    });
};
